<template>
  <CopyableText v-if="email" :text="email" :data-test="`user-email-${rowIndex}`" />
  <WdsText v-else secondary text="—" :data-test="`user-email-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import CopyableText from '@/components/CopyableText.vue'

const UserEmailColumn = graphql(`
  fragment UserEmailColumn on User {
    id
    email
  }
`)

const props = defineProps<{
  row: FragmentType<typeof UserEmailColumn>
  rowIndex?: number
}>()

const email = computed(() => useFragment(UserEmailColumn, props.row).email || null)
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
